import React from 'react';
import { styleIcon } from '../style_icon.js';
export function DoNotEnterIcon({ title = 'Do Not Enter Icon', ...rest }) {
    const style = styleIcon(rest);
    return (React.createElement("svg", { ...style, viewBox: "0 0 16 16" },
        !style['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M13 8.5C13 8.77612 12.7761 9 12.5 9H3.5C3.22388 9 3 8.77612 3 8.5V7.5C3 7.22382 3.22388 7 3.5 7H12.5C12.7761 7 13 7.22382 13 7.5V8.5ZM0.5 7.75384V8.24611C0.5 12.4513 3.59869 15.5 8.00003 15.5C12.4014 15.5 15.5 12.4502 15.5 8.24611V7.75384C15.5 3.54865 12.4014 0.5 8.00003 0.5C3.59869 0.5 0.5 3.54974 0.5 7.75384Z" })));
}
//# sourceMappingURL=do_not-enter_icon.js.map